module.exports = __webpack_public_path__ + "img/task_detail_setting_3.f77c24e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting-wizard/task_detail_setting_3.svg
// module id = FBUB
// module chunks = 1